export const isUndefinedType = <T>(variable: T) => typeof variable === 'undefined';

export const isNumberType = <T>(variable: T) => typeof variable === 'number';
